var _defs, _metadata, _rect, _g, _path, _g2, _path2, _g3, _g4, _circle, _g5;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgAni7(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlSpace: "preserve",
    width: "77.2523mm",
    height: "62.5082mm",
    style: {
      shapeRendering: "geometricPrecision",
      textRendering: "geometricPrecision",
      imageRendering: "optimizeQuality",
      fillRule: "evenodd",
      clipRule: "evenodd"
    },
    viewBox: "0 0 2195 1776",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", {
    type: "text/css"
  }, "\r\n    .str1 {stroke:black;stroke-width:5.6836}\r\n    .str0 {stroke:black;stroke-width:50.1237}\r\n    .str2 {stroke:black;stroke-width:50.1237;stroke-linecap:round}\r\n    .fil0 {fill:none}\r\n    .fil6 {fill:black}\r\n    .fil1 {fill:#A54A22}\r\n    .fil2 {fill:#F6C9C3}\r\n    .fil5 {fill:white}\r\n    .fil4 {fill:white;fill-rule:nonzero}\r\n    .fil3 {fill:white;fill-opacity:0.501961}\r\n  "), /*#__PURE__*/React.createElement("clipPath", {
    id: "id0"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M1098 334c-71,-1 -479,14 -713,519 -284,611 247,687 713,687 465,-1 996,-75 712,-687 -234,-505 -642,-520 -712,-519z"
  })))), /*#__PURE__*/React.createElement("g", {
    id: "Capa_x0020_1"
  }, _metadata || (_metadata = /*#__PURE__*/React.createElement("metadata", {
    id: "CorelCorpID_0Corel-Layer"
  })), /*#__PURE__*/React.createElement("g", {
    id: "_211450504"
  }, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    className: "fil0",
    width: 2195,
    height: 1776
  })), /*#__PURE__*/React.createElement("g", null, _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("circle", {
    className: "fil1 str0",
    transform: "matrix(0.39857 -0.437665 0.437665 0.39857 312.857 987.693)",
    r: 313
  }), /*#__PURE__*/React.createElement("circle", {
    className: "fil1 str0",
    transform: "matrix(-0.39857 -0.437665 -0.437665 0.39857 1882.5 987.693)",
    r: 313
  }), /*#__PURE__*/React.createElement("circle", {
    className: "fil2",
    transform: "matrix(0.254859 -0.279858 0.279858 0.254859 350.387 996.994)",
    r: 313
  }), /*#__PURE__*/React.createElement("circle", {
    className: "fil2",
    transform: "matrix(-0.254859 -0.279858 -0.279858 0.254859 1844.97 996.994)",
    r: 313
  }))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    className: "fil1",
    d: "M1098 334c-71,-1 -479,14 -713,519 -284,611 247,687 713,687 465,-1 996,-75 712,-687 -234,-505 -642,-520 -712,-519z"
  })), /*#__PURE__*/React.createElement("g", {
    style: {
      clipPath: "url(#id0)"
    }
  }, _g2 || (_g2 = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("ellipse", {
    className: "fil0 str1",
    cx: 33,
    cy: 559,
    rx: 36,
    ry: 75
  }), /*#__PURE__*/React.createElement("path", {
    className: "fil3",
    d: "M1098 1609c-306,0 -944,-354 -393,-350 -160,-119 -216,-362 -22,-475 194,-113 367,0 413,155l3 0c47,-155 220,-268 414,-155 194,113 138,356 -23,475 551,-4 -87,350 -392,350z"
  })))), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    className: "fil0 str0",
    d: "M1098 334c-71,-1 -479,14 -713,519 -284,611 247,687 713,687 465,-1 996,-75 712,-687 -234,-505 -642,-520 -712,-519z"
  })), _g3 || (_g3 = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "fil4",
    d: "M967 1034l-100 0 0 0 0 -5 0 -4 -1 -5 -1 -4 0 -4 -1 -4 -2 -4 -1 -4 -2 -4 -1 -4 -2 -3 -2 -4 -2 -3 -3 -3 -2 -3 -3 -3 -2 -3 -3 -2 -3 -3 -2 -2 -3 -2 -3 -2 -3 -2 -4 -1 -3 -1 -3 -2 -3 -1 -3 -1 -4 0 -3 -1 -4 0 -3 0 0 -100 9 0 9 1 9 1 8 2 9 2 8 2 8 3 8 4 8 4 8 4 7 4 7 5 7 6 6 5 6 6 6 6 6 7 5 6 5 7 5 8 4 7 4 8 4 8 3 8 3 8 3 8 2 9 2 9 1 9 1 9 1 9 0 9 0 0zm-172 184l0 -100 0 0 3 0 4 -1 3 0 4 -1 3 0 3 -1 3 -2 3 -1 4 -2 3 -1 3 -2 3 -2 2 -2 3 -3 3 -2 2 -3 3 -3 2 -3 3 -3 2 -3 2 -4 2 -3 1 -4 2 -4 1 -4 2 -4 1 -4 0 -4 1 -5 1 -4 0 -4 0 -5 100 0 0 9 -1 9 -1 9 -1 9 -2 9 -2 8 -3 9 -3 8 -3 8 -4 8 -4 8 -4 7 -5 7 -5 7 -5 7 -6 7 -6 6 -6 6 -6 5 -7 5 -7 5 -7 5 -8 4 -8 4 -8 3 -8 3 -8 3 -9 2 -8 2 -9 1 -9 1 -9 0 0 0zm-172 -184l100 0 0 0 0 5 0 4 1 4 0 5 1 4 1 4 2 4 1 4 2 4 1 4 2 3 2 4 2 3 3 3 2 3 2 3 3 3 3 2 2 3 3 2 3 2 3 2 3 1 3 2 3 1 4 2 3 1 3 0 4 1 3 0 3 1 4 0 0 100 -9 0 -9 -1 -9 -1 -9 -2 -8 -2 -9 -3 -8 -3 -8 -3 -7 -4 -8 -4 -7 -5 -7 -5 -7 -5 -6 -5 -6 -6 -6 -6 -6 -7 -5 -7 -5 -7 -5 -7 -4 -7 -4 -8 -4 -8 -3 -8 -3 -8 -3 -9 -2 -8 -2 -9 -1 -9 -1 -9 -1 -9 0 -9 0 0zm172 -184l0 100 0 0 -4 0 -3 0 -3 1 -4 0 -3 1 -3 1 -4 1 -3 2 -3 1 -3 2 -3 2 -3 2 -3 2 -2 3 -3 2 -3 3 -2 3 -2 3 -3 3 -2 3 -2 4 -2 3 -1 4 -2 4 -1 4 -2 4 -1 4 -1 4 0 4 -1 5 0 4 0 5 -100 0 0 -9 1 -9 1 -9 1 -9 2 -9 2 -9 3 -8 3 -8 3 -8 4 -8 4 -8 4 -7 5 -8 5 -7 5 -6 6 -7 6 -6 6 -6 6 -5 7 -6 7 -5 7 -4 8 -4 7 -4 8 -4 8 -3 9 -2 8 -2 9 -2 9 -1 9 -1 9 0 0 0z"
  }), /*#__PURE__*/React.createElement("path", {
    id: 1,
    className: "fil5",
    d: "M795 900c67,0 122,60 122,134 0,74 -55,134 -122,134 -68,0 -122,-60 -122,-134 0,-74 54,-134 122,-134z"
  })), /*#__PURE__*/React.createElement("circle", {
    className: "fil6",
    cx: 829,
    cy: 1036,
    r: 111
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "fil4",
    d: "M1228 1034l0 0 1 -9 0 -9 1 -9 2 -9 2 -9 2 -9 2 -8 3 -8 4 -8 3 -8 4 -8 5 -7 4 -8 5 -7 6 -6 5 -7 6 -6 6 -6 7 -5 6 -6 7 -5 8 -4 7 -4 8 -4 8 -4 8 -3 8 -2 9 -2 9 -2 8 -1 9 -1 9 0 0 100 -3 0 -4 0 -3 1 -3 0 -4 1 -3 1 -3 1 -3 2 -3 1 -3 2 -3 2 -3 2 -3 2 -3 3 -2 2 -3 3 -3 3 -2 3 -2 3 -2 3 -2 4 -2 3 -2 4 -2 4 -1 4 -1 4 -1 4 -1 4 -1 4 0 5 -1 4 0 5 0 0 -100 0zm172 184l0 0 -9 0 -9 -1 -8 -1 -9 -2 -9 -2 -8 -3 -8 -3 -8 -3 -8 -4 -7 -4 -8 -5 -7 -5 -6 -5 -7 -5 -6 -6 -6 -6 -5 -7 -6 -7 -5 -7 -4 -7 -5 -7 -4 -8 -3 -8 -4 -8 -3 -8 -2 -9 -2 -8 -2 -9 -2 -9 -1 -9 0 -9 -1 -9 100 0 0 5 1 4 0 4 1 5 1 4 1 4 1 4 1 4 2 4 2 4 2 3 2 4 2 3 2 3 2 3 3 3 3 3 2 2 3 3 3 2 3 2 3 2 3 1 3 2 3 1 3 2 3 1 4 0 3 1 3 0 4 1 3 0 0 0 0 100zm173 -184l0 0 -1 9 0 9 -1 9 -2 9 -2 9 -2 8 -2 9 -3 8 -4 8 -3 8 -4 8 -5 7 -4 7 -5 7 -6 7 -5 7 -6 6 -6 6 -7 5 -7 5 -7 5 -7 5 -7 4 -8 4 -8 3 -8 3 -8 3 -9 2 -9 2 -9 1 -8 1 -10 0 0 -100 4 0 3 -1 4 0 3 -1 3 0 4 -1 3 -2 3 -1 3 -2 3 -1 3 -2 3 -2 3 -2 3 -3 2 -2 3 -3 2 -3 3 -3 2 -3 2 -3 2 -4 2 -3 2 -4 1 -4 2 -4 1 -4 1 -4 1 -4 1 -5 0 -4 1 -4 0 -5 0 0 100 0zm-173 -184l0 0 10 0 8 1 9 1 9 2 9 2 8 2 8 3 8 4 8 4 7 4 7 4 7 5 7 6 7 5 6 6 6 6 5 7 6 6 5 7 4 8 5 7 4 8 3 8 4 8 3 8 2 8 2 9 2 9 2 9 1 9 0 9 1 9 -100 0 0 -5 -1 -4 0 -5 -1 -4 -1 -4 -1 -4 -1 -4 -2 -4 -1 -4 -2 -4 -2 -3 -2 -4 -2 -3 -2 -3 -3 -3 -2 -3 -3 -3 -2 -2 -3 -3 -3 -2 -3 -2 -3 -2 -3 -2 -3 -1 -3 -1 -3 -2 -4 -1 -3 -1 -3 0 -4 -1 -3 0 -4 0 0 0 0 -100z"
  }), /*#__PURE__*/React.createElement("path", {
    id: 1,
    className: "fil5",
    d: "M1400 900c-67,0 -122,60 -122,134 0,74 55,134 122,134 68,0 123,-60 123,-134 0,-74 -55,-134 -123,-134z"
  })), /*#__PURE__*/React.createElement("circle", {
    className: "fil6",
    cx: 1367,
    cy: 1036,
    r: 111
  }))), _g4 || (_g4 = /*#__PURE__*/React.createElement("g", {
    id: "_211451536"
  }, /*#__PURE__*/React.createElement("circle", {
    className: "fil5",
    cx: 1334,
    cy: 1035,
    r: 43
  }), /*#__PURE__*/React.createElement("circle", {
    className: "fil5",
    cx: 862,
    cy: 1035,
    r: 43
  }))), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    className: "fil6",
    cx: 1098,
    cy: 1302,
    r: 80
  })), _g5 || (_g5 = /*#__PURE__*/React.createElement("g", {
    id: "_211450768"
  }, /*#__PURE__*/React.createElement("path", {
    className: "fil0 str2",
    d: "M1097 1302c0,36 3,73 0,109 -4,53 -120,61 -127,-35"
  }), /*#__PURE__*/React.createElement("path", {
    className: "fil0 str2",
    d: "M1098 1302c0,36 -2,73 0,109 4,53 121,61 128,-35"
  })))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgAni7);
export default __webpack_public_path__ + "static/media/ani7.05ad5342e17420c1facbd720eef6fff1.svg";
export { ForwardRef as ReactComponent };